<template>
<div class="edit">
  <div class="edit_top">
    <router-link to="/beacons/edit" class="edit_router">
      {{edit}}
    </router-link>
  </div>
  <div class="detail">
    <div class="detail_contents">
      <div class="detail_top">
        <div class="beacon_id">
          <div class="beacon_id_label detail_label">
            {{locationIdLabel}}
          </div>
          <div class="beacon_id detail_top_title">
            {{beacon.locationId}}
          </div>
        </div>
      </div>
      <div class="detail_bottom">
        <div class="location_name_label detail_label">
          {{locationNameLabel}}
        </div>
        <div class='location_name'>
          {{beacon.locationName}}
        </div>
        <div class="uuid_label detail_label">
          {{uuidLabel}}
        </div>
        <div class='uuid'>
          {{beacon.uuid}}
        </div>
        <div class="major_label detail_label">
          {{majorLabel}}
        </div>
        <div class='major'>
          {{beacon.major}}
        </div>
        <div class="minor_label detail_label">
          {{minorLabel}}
        </div>
        <div class='minor'>
          {{beacon.minor}}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      edit: '編集',
      locationIdLabel: 'ビーコンID',
      locationNameLabel: '場所名',
      uuidLabel: 'UUID',
      majorLabel: 'メジャー値',
      minorLabel: 'マイナー値'
    }
  },
  computed: {
    beacon () {
      return this.$store.state.beacons.beacon
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/beacons/beaconDetail.vue